import { RegimeValues } from 'src/types'

import { Tips } from '../../types/fam-graphql'
import { ActionButtonProps } from '../../components/ActionButton'
import { NutritionalPreferences } from '../../types'
import {
  DRIED_VEGETABLES_FREQUENCY_STEP,
  FISH_FREQUENCY_STEP,
  FRUITS_VEGETABLES_QUANTITY_STEP,
  MEAT_FREQUENCY_STEP,
  STARCHY_FOODS_FREQUENCY_STEP,
} from '../NutritionalValues'
import tcPopin from '../tcPopin/tcPopin'

export const ObjectivesSteps = (
  t?: any,
  nutritionalValues?: any,
  tips?: any,
  isForPopin?: boolean
) => [
  FRUITS_VEGETABLES_QUANTITY_STEP(
    t,
    tips,
    false,
    [RegimeValues.NO_MEAT].includes(
      nutritionalValues?.[NutritionalPreferences.DIET_PRACTICE] ?? ''
    ),
    isForPopin
  ),
  STARCHY_FOODS_FREQUENCY_STEP(t, tips, false, isForPopin),
  DRIED_VEGETABLES_FREQUENCY_STEP(t, tips, false, isForPopin),
  {
    ...FISH_FREQUENCY_STEP(t, tips, false, isForPopin),
    disabled: [RegimeValues.NO_FISH, RegimeValues.NO_EGG].includes(
      nutritionalValues?.[NutritionalPreferences.DIET_PRACTICE] ?? ''
    ),
  },
  {
    ...MEAT_FREQUENCY_STEP(t, tips, false, isForPopin),
    disabled: [
      RegimeValues.NO_MEAT,
      RegimeValues.NO_FISH,
      RegimeValues.NO_EGG,
    ].includes(nutritionalValues?.[NutritionalPreferences.DIET_PRACTICE] ?? ''),
  },
]

export const objectivesSectionTransformer = (
  t: any,
  handleOnChange?: (name?: string, value?: string | number) => void,
  stepsValues?: any,
  tips?: Tips,
  handleValidate?: () => void,
  isValidate?: boolean
): any => ({
  handleOnChange,
  stepsValues,
  isValidate,
  validateButtonProps: {
    text: t('objectives_validate_cta'),
    variantType: 'button',
    variantColorScheme: 'black',
    actionProps: {
      onClick: () => {
        tcPopin({
          popin_name: `popin_${t(
            'objectives_validate_cta'
          )}_amorce nouveau menu_fam`,
        })
        handleValidate?.()
      },
    },
  } as ActionButtonProps,
  steps: ObjectivesSteps(t, stepsValues, tips),
})
